import { render, staticRenderFns } from "./AtmCartSuggestions.vue?vue&type=template&id=5d6ed037&scoped=true&"
import script from "./AtmCartSuggestions.vue?vue&type=script&lang=js&"
export * from "./AtmCartSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./AtmCartSuggestions.vue?vue&type=style&index=0&id=5d6ed037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ed037",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6ed037')) {
      api.createRecord('5d6ed037', component.options)
    } else {
      api.reload('5d6ed037', component.options)
    }
    module.hot.accept("./AtmCartSuggestions.vue?vue&type=template&id=5d6ed037&scoped=true&", function () {
      api.rerender('5d6ed037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/components/AtmCartSuggestions.vue"
export default component.exports